import React, { useEffect } from 'react';
import { checkPermission, getSelectList } from '../../config/utils';
import { featureSubmodule, settings, SUBF_MARKETPLACEINTEGRATION } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import { marketPlaceIntegrationListing } from '../../store/actions/marketplace.action';
import { Tooltip as WmsTooltip } from "react-tooltip";
import { fetchCompanyFilters, getFilterSellers } from '../../store/actions/rateCard';
import Select from "react-select";
import LoaderSpinner from '../common/Loader';
import _ from 'lodash';
import PropTypes from 'prop-types';

/* istanbul ignore next */
const CompanySellerFilter = (props) => {
    const { getPendingOrderNumbers, integrationValue, setIntegrationValue } = props;
    const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
    const createdBy = useSelector((state) => state.auth.user);
    const [marketIntegrationList, setMarketIntegrationList] = React.useState([]);
    const [loader, setLoader] = React.useState(false);
    const [companyList, setCompanyList] = React.useState([]);
    const [allSellers, setAllSellers] = React.useState([]);
    const [formData, setFormData] = React.useState({
        company: 0,
        seller: 0,
    });

    const dispatch = useDispatch();
    const { filterCompanies, filterAllSellers } = useSelector((state) => state.RateCardReducer);

    useEffect(() => {
        let data = {
            pageIndex: 1,
            pageSize: 10,
            sortColumn: 'name',
            sortOrder: 'ascending'
        };
        let sellerData = {
            "pageIndex": 1,
            "pageSize": 10,
            "sortColumn": "name",
            "sortOrder": "ASCENDING",
            "companyIdList": [0],
            screenType: 2,
        };
        dispatch(fetchCompanyFilters(data));
        dispatch(getFilterSellers(sellerData));
    }, []);

    useEffect(() => {
        let companyList = filterCompanies?.Entity?.listCompanyMasterOrdersEntity || [];
        let sellerList = filterAllSellers?.EntityList || [];
        if (companyList.length) {
            setCompanyList(getSelectList(filterCompanies?.Entity?.listCompanyMasterOrdersEntity, 'Id', 'name'));
        }
        if (sellerList.length) {
            setAllSellers(getSelectList(sellerList, 'id', 'sellerName'));
        }
    }, [filterCompanies, filterAllSellers]);

    const fetchMarketPlaceListing = async () => {
        let data = {
            company_seller_id: String(createdBy?.Value?.companySellerId),
            pageSize: '2000',
            pageIndex: '1',
        };
        setLoader(true);
        let resData = await marketPlaceIntegrationListing(data);
        if (resData && resData?.data?.Status === 200) {
            if (resData?.data?.EntityList?.length) {
                let getUnique = _.uniqBy(resData?.data?.EntityList, 'integration_id');
                let filteredData = getUnique.filter(order => {
                    return Number(order.company_id) === formData?.company?.Id && Number(order.seller_id) === formData?.seller?.id;
                });
                setMarketIntegrationList(filteredData);
            }
        }
        setLoader(false);
    };

    const handleIntegrationChange = (event) => {
        const { value } = event.target;
        setIntegrationValue(value);
    };

    const handleFilterMarketPlace = async () => {
        getPendingOrderNumbers();
    };

    const handleChange = (value, name) => {
        if (name === "company") {
            let data = {
                companyIdList: [value.Id],
                sortColumn: "name",
                sortOrder: "DESCENDING",
                screenType: 2,
            };
            dispatch(getFilterSellers(data));
            setFormData({
                ...formData,
                [name]: value,
                seller: {},
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    }

    useEffect(() => {
        if (formData?.company?.Id && formData?.seller?.id) {
            fetchMarketPlaceListing();
        }
    }, [formData]);

    return (
        <>
            <div className="shipment-list mb-3">
                <label className="mb-0 orderrefresh" htmlFor='company'>Company</label>
                <Select
                    isMulti={false}
                    options={companyList}
                    classNamePrefix="list"
                    id='company'
                    name="company"
                    value={formData?.company}
                    onChange={(value) =>
                        handleChange(value, "company")
                    }
                    closeMenuOnSelect={true}
                />
            </div>
            <div className="shipment-list mb-3">
                <label className="mb-0 orderrefresh" htmlFor='seller'>Seller</label>
                <Select
                    isMulti={false}
                    closeMenuOnSelect={true}
                    options={allSellers}
                    classNamePrefix="list"
                    id='seller'
                    name="seller"
                    value={formData?.seller}
                    onChange={(value) =>
                        handleChange(value, "seller")
                    }
                />
            </div>
            {loader && (<LoaderSpinner />)}
            {checkPermission(settings, SUBF_MARKETPLACEINTEGRATION, '', featureSubmodule, employeePermissions) && (
                <>
                    {marketIntegrationList.length > 0 && (
                        <>
                            <div className="orderrefresh">
                                Marketplace Integration
                            </div>
                            <div className="mb-20 marketPlaceInt">
                                <select
                                    className="form-control integration"
                                    value={integrationValue}
                                    name={"integration"}
                                    onChange={(e) => handleIntegrationChange(e)}
                                >
                                    <option value={''}>Select Integration</option>
                                    {marketIntegrationList?.map((item) => (
                                        <option
                                            value={item.integration_id}
                                            key={item.integration_id}
                                        >
                                            {item.integration_name}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    className="cus-primary-bg-btn custom-btn-shipment searchBtn"
                                    onClick={handleFilterMarketPlace}
                                    id="filterInte"
                                    disabled={Number(integrationValue) === 0}
                                >
                                    <i
                                        className="fa fa-search"
                                        aria-hidden="true"
                                    />
                                </button>
                                <WmsTooltip
                                    anchorId={"filterInte"}
                                    content={"Filter Integration"}
                                />
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
}

CompanySellerFilter.propTypes = {
    getPendingOrderNumbers: PropTypes.func.isRequired,
    integrationValue: PropTypes.string.isRequired,
    setIntegrationValue: PropTypes.func.isRequired
};

export default CompanySellerFilter;